import { businessDateRange } from 'config/time';
import { ClientSelection } from './selection';

/**
 * ADM-21-AC2。配送先分析のグラフと CSV で、同じ集計 API・同じ条件・同じ範囲を使う。
 *
 * 以前はグラフが集計 API（終了した作業で、開始が期間の始め以降・終了が期間の終わり以前）を、
 * CSV が作業記録を画面で合計（開始だけで期間を判定し、期間をまたぐ作業・終わっていない作業も
 * 含む）を使い、同じ配送先の時間が食い違っていた。
 */

export type SummaryKind = 'with_tasks' | 'without_tasks';

/** 集計 API の URL。期間は日本時間の業務日、作業は task_ids、配送先は id__in。 */
export function summarizeUrl(
  kind: SummaryKind,
  selection: ClientSelection,
  dateRange: { start: string; end: string }
): string {
  let url = `/v1/client_deliveries/summarize_spent_hour_${kind}/?`;
  if (selection.taskId !== null && selection.taskId !== undefined) {
    // ADM-12。作業の絞り込みは task_ids。id__in は配送先のID。
    url += `task_ids=${encodeURIComponent(selection.taskId)}&`;
  }
  if (selection.clientIds.length > 0) {
    url += `id__in=${selection.clientIds.join(',')}&`;
  }
  const range = businessDateRange(dateRange.start, dateRange.end);
  url += `start_time=${encodeURIComponent(range.gte ?? '')}&stop_time=${encodeURIComponent(
    range.lte ?? ''
  )}`;
  return url;
}

/**
 * 集計 API が数える作業記録か（services/backend/api/views.py の summarize_spent_hour_*）。
 * 終了していて、開始が期間の始め以降、終了が期間の終わり以前。
 */
export function isCountedSession(
  session: { start_time?: string | null; stop_time?: string | null },
  dateRange: { start: string; end: string }
): boolean {
  if (!session.start_time || !session.stop_time) return false;
  const { gte, lte } = businessDateRange(dateRange.start, dateRange.end);
  const start = Date.parse(session.start_time);
  const stop = Date.parse(session.stop_time);
  if (Number.isNaN(start) || Number.isNaN(stop)) return false;
  if (gte && start < Date.parse(gte)) return false;
  // 終わりはマイクロ秒の最後（.999999）。Date はミリ秒までなので、翌日0時より前で比べる。
  if (lte && stop >= Date.parse(lte) + 1) return false;
  return true;
}
